module.exports = __webpack_public_path__ + "img/equipos-de-sala-gal-2.cd9f3bf1.png";